import React, { useState } from "react";
import styled from "styled-components";
import {
  Button,
  FileInput,
  Group,
  Image,
  LoadingOverlay,
  Text,
  TextInput,
  Textarea,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useMutation, useQuery } from "@apollo/client";
import { useNavigate, useParams } from "react-router-dom";

import { SINGLE_NEWS, UPDATE_NEWS } from "../../gqls/news";

export const UpdateNewsPage = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(undefined);
  const [defaultImage, setDefaultImage] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const [updateNews] = useMutation(UPDATE_NEWS);
  const navigate = useNavigate();
  const params = useParams();

  const { loading: getting } = useQuery(SINGLE_NEWS, {
    variables: { where: { id: params.id } },
    onCompleted: (data) => {
      const news = data?.singleNews;
      if (news) {
        setTitle(news.title || "");
        setDescription(news.description || "");
        if (news.image) setDefaultImage(news.image);
      }
    },
    onError: (err) => {
      console.error(err);
      notifications.show({
        color: "red",
        title: "Произошла ошибка, повторите еще раз",
      });
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let image;
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        const photoResponse = await fetch("/api/admin/upload", {
          method: "POST",
          body: formData,
          headers: { authorization: localStorage.getItem("accessToken") },
        }).then((res) => res.json());
        if (!photoResponse?.filename) {
          notifications.show({
            color: "red",
            title: "Произошла ошибка, повторите еще раз",
          });
          setLoading(false);
          return;
        }
        image = photoResponse.filename;
      }
      await updateNews({
        variables: {
          where: { id: params.id },
          data: { title, description, image, products: [] },
        },
      });
      navigate(`/news/${params.id}`);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <>
      <Group align="center" justify="space-between">
        <Text fw="600">Изменить новость</Text>
      </Group>
      <Form onSubmit={handleSubmit}>
        <LoadingOverlay
          visible={getting}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <TextInput
          type="text"
          placeholder="Введите заголовок..."
          label="Заголовок"
          required
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <Textarea
          label="Описание"
          placeholder="Введите описание..."
          mt={16}
          autosize
          minRows={6}
          required
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <FileInput
          label="Изображение"
          placeholder="Нажмите, чтобы выбрать изображение"
          required
          mt={16}
          value={file}
          onChange={setFile}
        />
        {!file && defaultImage ? (
          <Image
            src={`/uploads/${defaultImage}`}
            alt={defaultImage}
            mt={16}
            width={200}
          />
        ) : null}
        <Button loading={loading} type="submit" mt={16}>
          Изменить
        </Button>
      </Form>
    </>
  );
};

const Form = styled.form`
  max-width: 500px;
  margin-top: 8px;
  position: relative;
`;
